export const SCHOOL_LOGO = "https://customer-assets.emergentagent.com/job_noor-school-hub-1/artifacts/10mx3v9g_school_logo.png";
export const SCHOOL_NAME = "مدارس العلم النافع الأهلية";
export const SCHOOL_SUB = "ابتدائية ومتوسطة وثانوية";

export const STAGES = {
  primary: "المرحلة الابتدائية",
  middle: "المرحلة المتوسطة",
  high: "المرحلة الثانوية",
};

export const STAGE_KEYS = ["primary", "middle", "high"];

export const GRADES_BY_STAGE = {
  primary: [
    "الصف الأول الابتدائي",
    "الصف الثاني الابتدائي",
    "الصف الثالث الابتدائي",
    "الصف الرابع الابتدائي",
    "الصف الخامس الابتدائي",
    "الصف السادس الابتدائي",
  ],
  middle: [
    "الصف الأول المتوسط",
    "الصف الثاني المتوسط",
    "الصف الثالث المتوسط",
  ],
  high: [
    "الصف الأول الثانوي",
    "الصف الثاني الثانوي",
    "الصف الثالث الثانوي",
  ],
};

export const GRADES = [
  ...GRADES_BY_STAGE.primary,
  ...GRADES_BY_STAGE.middle,
  ...GRADES_BY_STAGE.high,
];

export function stageFromGrade(grade) {
  if (!grade) return null;
  if (grade.includes("الابتدائي")) return "primary";
  if (grade.includes("المتوسط")) return "middle";
  if (grade.includes("الثانوي")) return "high";
  return null;
}

// Sections: each grade gets sections labeled "<grade> -1", "-2", ... up to 8
export function sectionsForGrade(grade, count = 8) {
  if (!grade) return [];
  return Array.from({ length: count }, (_, i) => `${grade} -${i + 1}`);
}

export const ROLES = {
  super_admin: "المسؤول الرئيسي",
  admin: "المدير",
  supervisor: "المشرف",
  student_affairs: "وكيل الشؤون الطلابية",
  student_guide: "الموجه الطلابي",
  teacher: "المعلم",
};

export const ROLE_KEYS = ["super_admin", "admin", "supervisor", "student_affairs", "student_guide", "teacher"];

export const CURRENT_ACADEMIC_YEAR = "1448 / 1449";

export const ACADEMIC_YEARS = [
  "1447 / 1448",
  "1448 / 1449",
  "1449 / 1450",
  "1450 / 1451",
  "1451 / 1452",
  "1452 / 1453",
];

// Grade promotion mapping (next grade after end of year)
export const GRADE_PROMOTION = {
  "الصف الأول الابتدائي": "الصف الثاني الابتدائي",
  "الصف الثاني الابتدائي": "الصف الثالث الابتدائي",
  "الصف الثالث الابتدائي": "الصف الرابع الابتدائي",
  "الصف الرابع الابتدائي": "الصف الخامس الابتدائي",
  "الصف الخامس الابتدائي": "الصف السادس الابتدائي",
  "الصف السادس الابتدائي": "الصف الأول المتوسط",
  "الصف الأول المتوسط": "الصف الثاني المتوسط",
  "الصف الثاني المتوسط": "الصف الثالث المتوسط",
  "الصف الثالث المتوسط": "الصف الأول الثانوي",
  "الصف الأول الثانوي": "الصف الثاني الثانوي",
  "الصف الثاني الثانوي": "الصف الثالث الثانوي",
  "الصف الثالث الثانوي": null, // Graduated
};

// Role-based permission helpers
const SUPER = (role) => role === "super_admin";

// Granular permission helper: super_admin bypasses all checks
function hasPerm(user, perm) {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  return Array.isArray(user.permissions) && user.permissions.includes(perm);
}

// Permission keys catalog (mirrored from backend) — used for the UserManagement UI
export const PERMISSIONS = [
  { key: "students.view",      group: "students",     label: "عرض الطلاب" },
  { key: "students.create",    group: "students",     label: "إضافة طالب" },
  { key: "students.edit",      group: "students",     label: "تعديل طالب" },
  { key: "students.delete",    group: "students",     label: "حذف طالب" },
  { key: "students.import",    group: "students",     label: "استيراد من Excel" },
  { key: "students.promote",   group: "students",     label: "الترقية الجماعية" },
  { key: "attendance.take",    group: "attendance",   label: "تسجيل الغياب" },
  { key: "attendance.view",    group: "attendance",   label: "عرض تقارير الغياب" },
  { key: "lesson_plans.view",  group: "lesson_plans", label: "عرض الخطط الدراسية" },
  { key: "lesson_plans.write", group: "lesson_plans", label: "كتابة/تعديل الخطط" },
  { key: "reports.view",       group: "reports",      label: "عرض تقارير الطلاب" },
  { key: "whatsapp.send",      group: "whatsapp",     label: "إرسال إشعار غياب (واتساب)" },
  { key: "whatsapp.view_log",  group: "whatsapp",     label: "عرض سجل الإشعارات" },
  { key: "pickup.view",             group: "pickup", label: "الدخول لنظام استدعاء الطالب (كمعلم)" },
  { key: "pickup.manage",           group: "pickup", label: "إدارة طلبات الاستدعاء وتأكيد التسليم" },
  { key: "pickup.manage_guardians", group: "pickup", label: "إدارة حسابات أولياء الأمور (حذف/ربط)" },
  { key: "pickup.manage_settings",  group: "pickup", label: "إدارة إعدادات نظام الاستدعاء (الأوقات والمُدد)" },
  { key: "pickup.duty_call",        group: "pickup", label: "المناوب" },
  { key: "circulars.issue",     group: "circulars", label: "إصدار التعاميم" },
  { key: "circulars.view_sign", group: "circulars", label: "الاطلاع والتوقيع على التعاميم" },
];

export const PERMISSION_GROUPS = [
  { key: "students",     label: "الطلاب" },
  { key: "attendance",   label: "الغياب" },
  { key: "lesson_plans", label: "الخطط الدراسية" },
  { key: "reports",      label: "التقارير" },
  { key: "whatsapp",     label: "إشعارات الواتساب" },
  { key: "pickup",       label: "استدعاء الطالب" },
  { key: "circulars",    label: "التعاميم الداخلية" },
];

export const ALL_PERMISSION_KEYS = PERMISSIONS.map(p => p.key);

export const ROLE_PRESETS = {
  super_admin: [...ALL_PERMISSION_KEYS],
  admin: [...ALL_PERMISSION_KEYS],
  supervisor: ["students.view", "attendance.view", "lesson_plans.view", "reports.view", "whatsapp.view_log"],
  student_affairs: [
    "students.view", "students.create", "students.edit", "students.delete",
    "attendance.take", "attendance.view",
    "lesson_plans.view",
    "reports.view",
    "whatsapp.send", "whatsapp.view_log",
  ],
  student_guide: [
    "students.view", "attendance.view", "lesson_plans.view",
    "whatsapp.send", "whatsapp.view_log",
  ],
  teacher: [
    "students.view",
    "attendance.take", "attendance.view",
    "lesson_plans.view", "lesson_plans.write",
  ],
};

export const can = {
  // user-management: super_admin only
  manageUsers: (userOrRole) => {
    const role = typeof userOrRole === "string" ? userOrRole : userOrRole?.role;
    return SUPER(role);
  },
  manageSuperAdmins: (userOrRole) => {
    const role = typeof userOrRole === "string" ? userOrRole : userOrRole?.role;
    return SUPER(role);
  },
  // The rest accept either a user object (preferred) or a role string (legacy)
  importStudents:        (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "students.import"),
  promoteStudents:       (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "students.promote"),
  createStudent:         (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "students.create"),
  editStudent:           (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "students.edit"),
  deleteStudent:         (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "students.delete"),
  viewStudents:          (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "students.view"),
  viewReports:           (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "reports.view"),
  takeAttendance:        (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "attendance.take"),
  viewAttendanceReports: (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "attendance.view"),
  writeLessonPlan:       (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "lesson_plans.write"),
  viewLessonPlans:       (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "lesson_plans.view"),
  sendWhatsapp:          (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "whatsapp.send"),
  viewWhatsappLog:       (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "whatsapp.view_log"),
  viewPickup:            (u) => typeof u === "string" ? u === "super_admin" : (hasPerm(u, "pickup.view") || hasPerm(u, "pickup.manage")),
  managePickup:          (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "pickup.manage"),
  manageGuardians:       (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "pickup.manage_guardians"),
  manageSettingsPickup:  (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "pickup.manage_settings"),
  dutyCallPickup:        (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "pickup.duty_call"),
  issueCirculars:        (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "circulars.issue"),
  viewSignCirculars:     (u) => typeof u === "string" ? u === "super_admin" : hasPerm(u, "circulars.view_sign"),
};

// Format phone number for wa.me (Saudi default)
export function formatWaPhone(phone) {
  if (!phone) return null;
  let d = String(phone).replace(/\D/g, "");
  if (d.startsWith("966")) return d;
  if (d.startsWith("00966")) return d.slice(2);
  if (d.startsWith("0")) d = d.slice(1);
  return "966" + d;
}

export function buildWaUrl(phone, message) {
  const p = formatWaPhone(phone);
  if (!p) return null;
  return `https://wa.me/${p}?text=${encodeURIComponent(message)}`;
}

// Lesson plan grid
export const PLAN_DAYS = [
  { key: "sunday", label: "الأحد" },
  { key: "monday", label: "الاثنين" },
  { key: "tuesday", label: "الثلاثاء" },
  { key: "wednesday", label: "الأربعاء" },
  { key: "thursday", label: "الخميس" },
];

export const PLAN_PERIODS = [
  { key: 1, label: "الأولى" },
  { key: 2, label: "الثانية" },
  { key: 3, label: "الثالثة" },
  { key: 4, label: "الرابعة" },
  { key: 5, label: "الخامسة" },
  { key: 6, label: "السادسة" },
  { key: 7, label: "السابعة" },
];

// Returns the Sunday of the week containing the given date (start of school week in KSA)
export function weekStartOf(dateStr) {
  const d = new Date(dateStr || new Date().toISOString().slice(0, 10));
  const day = d.getDay(); // 0=Sunday, 6=Saturday
  // distance to last Sunday
  const diff = day === 6 ? 1 : -day; // if Saturday, +1 to next Sunday; otherwise back to current Sunday
  const sunday = new Date(d);
  sunday.setDate(d.getDate() + diff);
  return sunday.toISOString().slice(0, 10);
}

export function weekEndOf(weekStart) {
  const d = new Date(weekStart);
  d.setDate(d.getDate() + 4); // Sunday + 4 = Thursday
  return d.toISOString().slice(0, 10);
}
